"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscribeToVolumeIndicator = subscribeToVolumeIndicator;
var _ActiveSpeakerInSession = require("@studio/constants/ActiveSpeakerInSession");
var _underscore = require("underscore");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function subscribeToVolumeIndicator(dispatch, setAttendeeMuteStatus, meetingSession, attendeeId, setAttendeeVoiceIntensity) {
  var debouncedCall, attendeeVoiceIntensity;
  var debouncingWindow = 0;
  meetingSession.audioVideo.realtimeSubscribeToVolumeIndicator(attendeeId, function (attendeeId, volume, muted) {
    if (typeof muted === 'boolean' && !!setAttendeeMuteStatus) {
      dispatch(setAttendeeMuteStatus(attendeeId, muted));
    }
    if (!!setAttendeeVoiceIntensity) {
      attendeeVoiceIntensity = volume;
      // Debounce the call to setAttendeeVoiceIntensity to avoid setting the state too frequently
      if (!debouncedCall || attendeeVoiceIntensity > _ActiveSpeakerInSession.ACTIVE_SPEAKER_INTENSITY_THRESHOLD) {
        // reset debouncing window if the intensity is above the threshold
        // to show the indicator between natural speech lags
        if (debouncedCall) {
          debouncedCall.cancel();
        }
        debouncedCall = (0, _underscore.debounce)(function () {
          // show indicator immediately but remove it with 1.5 seconds debouncing
          if (attendeeVoiceIntensity > _ActiveSpeakerInSession.ACTIVE_SPEAKER_INTENSITY_THRESHOLD) {
            debouncingWindow = 1500;
          } else {
            debouncingWindow = 0;
          }
          dispatch(setAttendeeVoiceIntensity(_defineProperty({}, attendeeId, attendeeVoiceIntensity)));
          debouncedCall = null;
        }, debouncingWindow);
        debouncedCall();
      }
    }
  });
}